import { createSelector } from '@reduxjs/toolkit';
import { selectBedsLabel } from './selectBedsLabel';
import { selectBedsValue } from './selectBedsValue';
import { MAX_VALUE, MIN_VALUE } from './constants';

export const selectBedsFilter = createSelector([selectBedsValue, selectBedsLabel], (value, label) => {
  return {
    value,
    label,
    min: MIN_VALUE,
    max: MAX_VALUE,
  };
});
